import styled from 'styled-components'

export const LocationEditModalWrapper = styled.div``
